import { Component, Input, Output, EventEmitter } from '@angular/core';

interface Notification2 {
  text: string;
  buttonText: string;
}

@Component({
  selector: 'mapfre-notification-2',
  templateUrl: './notification-2.component.html',
  styleUrls: ['./notification-2.component.scss']
})
export class Notification2Component {
  @Input() type: 'SUCCESS' | 'WARNING' = 'WARNING';
  @Input() data: Notification2;
  @Input() showCloseBtn = false;
  @Output() close = new EventEmitter();
  @Output() action = new EventEmitter();

  constructor() {}

  onClose() {
    this.close.emit('close');
  }

  onAction() {
    this.action.emit('action');
  }
}
